<template>
  <!-- <div class="text-center"> -->
  <!-- @click:outside="clickOutside" -->
  <v-dialog v-model="dialog" max-width="800" persistent>
    <template v-slot:activator="{ on, attrs }">
      <p
        id="fpbFormAdd"
        v-if="param.act === 'add'"
        v-bind="attrs"
        v-on="on"
        @click="add"
      ></p>
      <p id="fpbFormEdit" v-else v-bind="attrs" v-on="on" @click="update"></p>
    </template>
    <!-- <div v-if="detail !== null">
      <v-container style="max-width:100%;background: white; border-radius: 5px"> -->
    <v-form
      v-if="detail !== null"
      lazy-validation
      :readonly="detail.status.id !== 0"
      @submit.prevent="submit"
      ref="entryForm"
      style="position: relative"
      :disabled="
        getUserProfile.level.find(({ id }) => id === '41') !== undefined
      "
    >
      <v-card>
        <v-card-title
          class="text-h5 grey lighten-2"
          style="position: sticky; top: 0px; z-index: 2"
        >
          Edit FPB
        </v-card-title>
        <!-- <div>
              <v-btn
                type="submit"
                tile
                color="success"
                small
                class="ma-2"
                style="color: white"
                :loading="loading"
                :disabled="detail.status.id !== 0"
              >
                simpan
              </v-btn>

              <v-btn
                small
                tile
                color="pink"
                class="ma-2"
                style="color: white"
                @click="close"
                :loading="loading"
              >
                tutup
              </v-btn>
            </div> -->

        <v-card-text
          class="d-flex justify-center align-center"
          style="margin-top: 10px"
        >
          <v-row no-gutters>
            <v-col
              cols="12"
              md="5"
              style="
                padding: 0 0 0 15px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 10px;
              "
            >
              <v-col
                cols="5"
                style="
                  padding: 0;
                  justify-content: flex-start;
                  align-items: center;
                  display: flex;
                "
              >
                <p
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Ada Budget ?
                </p>

                <v-checkbox
                  v-model="form.has_budget"
                  style="margin: 0 0 0 10px; height: 25px; padding: 0"
                ></v-checkbox>
              </v-col>
              <v-col
                cols="7"
                style="
                  padding: 0;
                  justify-content: flex-start;
                  align-items: center;
                  display: flex;
                "
              >
                <v-tooltip
                  v-if="param.act !== 'update' && detail.budget_plan == null"
                  bottom
                  color="info"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      color="blue"
                      class="mr-1"
                      >mdi-information-outline</v-icon
                    >
                  </template>
                  <span>Untuk mengaktifkan kolom ini, fpb harus project</span>
                </v-tooltip>
                <p
                  v-if="param.act !== 'update' && detail.budget_plan == null"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Pilih dari katalog ?
                </p>
                <v-checkbox
                  v-if="param.act !== 'update' && detail.budget_plan == null"
                  v-model="select_from_catalogue"
                  :false-value="false"
                  :true-value="true"
                  style="margin: 0 0 0 10px; height: 25px; padding: 0"
                  :disabled="param.act === 'add' && detail.project === null"
                ></v-checkbox>
              </v-col>
            </v-col>
            <v-col cols="12" md="2" style="padding: 0"></v-col>
            <v-col cols="12" md="5" style="padding: 0">
              <div
                v-if="param.act === 'add'"
                style="padding: 0 10px; margin-bottom: 20px"
              >
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    {{
                      !select_from_catalogue
                        ? 'Nama Produk'
                        : detail.budget_plan == null
                        ? 'Item Katalog'
                        : 'Item RAB'
                    }}
                  </p>
                </v-col>
                <v-col
                  v-if="!select_from_catalogue"
                  cols="12"
                  style="padding: 0"
                >
                  <v-textarea
                    v-model="form.product.name"
                    dense
                    outlined
                    auto-grow
                    rows="1"
                    style="height: 40px"
                    :rules="itemNameRules"
                  />
                </v-col>
                <v-col v-else cols="12" style="padding: 0">
                  <v-autocomplete
                    v-model="selected"
                    :items="catalogueItems"
                    :filter="customFilter"
                    clearable
                    outlined
                    item-text="product.name"
                    item-value="id"
                    hide-details
                    hide-no-data
                    return-object
                    label=""
                    :loading="loading"
                    :search-input.sync="search"
                    style="margin: 0"
                    dense
                    @keydown.enter.prevent="enterSearch(search)"
                    :rules="itemNameRules"
                  >
                    <template v-slot:prepend-item>
                      <div
                        style="
                          padding: 0 15px;
                          position: sticky;
                          top: 0;
                          z-index: 2;
                        "
                      >
                        <div
                          style="
                            padding: 0 25px;
                            height: 25px;
                            background: black;
                            color: white;
                            border: 2px solid black;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                          "
                        >
                          <v-toolbar-title
                            style="
                              text-align: left;
                              font-size: 14px;
                              padding: 0;
                              width: 200px;
                            "
                          >
                            Item Name
                          </v-toolbar-title>
                          <v-divider class="mx-3" inset vertical></v-divider>
                          <v-toolbar-title
                            style="
                              text-align: left;
                              font-size: 14px;
                              padding: 0;
                              width: 120px;
                            "
                          >
                            Item Code
                          </v-toolbar-title>

                          <v-divider class="mx-3" inset vertical></v-divider>

                          <v-toolbar-title
                            style="
                              text-align: left;
                              font-size: 14px;
                              padding: 0;
                              width: 200px;
                            "
                          >
                            Supplier Catalog
                          </v-toolbar-title>
                          <v-divider class="mx-3" inset vertical></v-divider>
                          <v-toolbar-title
                            style="
                              text-align: left;
                              font-size: 14px;
                              padding: 0;
                              width: 120px;
                            "
                          >
                            Supplier code
                          </v-toolbar-title>
                        </div>
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <!-- <div
                        style="width:800px; background:rgba(255,255,255,0.1);"
                      > -->
                      <!-- <v-expansion-panels
                        accordion
                        flat
                        light
                        style="width:800px;"
                      > -->
                      <!-- <v-expansion-panel> -->
                      <!-- <v-expansion-panel-header
                          hide-actions
                          style="border:1px solid rgba(0,0,0,0.1);"
                        > -->
                      <v-card
                        rounded
                        color="transparent"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                          width: 800px;
                          padding: 7px;
                        "
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-toolbar-title
                              v-bind="attrs"
                              v-on="on"
                              style="
                                text-align: left;
                                font-size: 14px;
                                padding: 0;
                                width: 200px;
                              "
                            >
                              {{ item.product.name }}
                            </v-toolbar-title>
                          </template>
                          <span>{{ item.product.name }}</span>
                        </v-tooltip>
                        <v-divider class="mx-3" inset vertical></v-divider>
                        <v-toolbar-title
                          style="
                            text-align: left;
                            font-size: 14px;
                            padding: 0;
                            width: 120px;
                          "
                        >
                          #{{ item.product.code }}
                        </v-toolbar-title>

                        <v-divider class="mx-3" inset vertical></v-divider>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-toolbar-title
                              v-bind="attrs"
                              v-on="on"
                              style="
                                text-align: left;
                                font-size: 14px;
                                padding: 0;
                                width: 200px;
                              "
                            >
                              {{
                                item.vendor.name !== null
                                  ? item.vendor.name
                                  : ''
                              }}
                            </v-toolbar-title>
                          </template>
                          <span>{{
                            item.vendor.name !== null ? item.vendor.name : ''
                          }}</span>
                        </v-tooltip>

                        <v-divider class="mx-3" inset vertical></v-divider>

                        <v-toolbar-title
                          style="
                            text-align: left;
                            font-size: 14px;
                            padding: 0;
                            width: 120px;
                          "
                        >
                          #{{
                            item.vendor.code !== null ? item.vendor.code : ''
                          }}
                        </v-toolbar-title>
                      </v-card>
                      <!-- </v-expansion-panel-header> -->
                      <!-- </v-expansion-panel> -->
                      <!-- </v-expansion-panels> -->
                      <!-- </div> -->
                    </template>
                  </v-autocomplete>
                  <p
                    v-if="odooItem !== null"
                    :style="`font: 8px; color: ${
                      odooItem.status == '00' ? 'green' : 'red'
                    }`"
                  >
                    {{ '(' + odooItem.code + ') ' + odooItem.message }}
                  </p>
                </v-col>
              </div>
            </v-col>

            <!-- ---------------------IF act === UPDATE-------------------- -->
            <v-col
              v-if="param.act === 'update'"
              cols="12"
              md="5"
              style="padding: 0"
            >
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Item Name
                    <v-tooltip
                      v-if="form.product != null && form.product.id != null"
                      right
                      color="info"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="openDetailItem(form)"
                          style="cursor: pointer"
                          x-small
                          color="primary"
                        >
                          mdi-open-in-new
                        </v-icon>
                      </template>
                      <span>Lihat detail item</span>
                    </v-tooltip>
                  </p>
                </v-col>
                <v-col
                  v-if="form.product !== undefined"
                  cols="12"
                  style="padding: 0"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        :value="form.product.name"
                        dense
                        outlined
                      />
                    </template>
                    <span>{{ form.product.name }}</span>
                  </v-tooltip>
                </v-col>
              </div>
            </v-col>
            <v-col
              v-if="param.act === 'update'"
              cols="12"
              md="2"
              style="padding: 0"
            ></v-col>
            <v-col
              v-if="param.act === 'update'"
              cols="12"
              md="5"
              style="padding: 0"
            >
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Item Code
                    <!-- <v-tooltip right color="info">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="openDetailItem(form.product)"
                          :style="`{{form.product != null && form.product.id != null ? 'cursor:pointer;' : ''}}`"
                          x-small
                          color="primary"
                        >
                          mdi-open-in-new
                        </v-icon>
                      </template>
                      <span>Lihat detail item</span>
                    </v-tooltip> -->
                  </p>
                </v-col>
                <v-col
                  v-if="form.product !== undefined"
                  cols="12"
                  style="padding: 0"
                >
                  <v-text-field
                    readonly
                    :value="form.product.code"
                    dense
                    outlined
                  />
                </v-col>
              </div>
            </v-col>

            <v-col
              v-if="param.act === 'update'"
              cols="12"
              md="5"
              style="padding: 0"
            >
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Supplier Name
                  </p>
                </v-col>
                <v-col
                  v-if="form.vendor !== undefined"
                  cols="12"
                  style="padding: 0"
                >
                  <v-text-field
                    readonly
                    :value="form.vendor.name"
                    dense
                    outlined
                  />
                </v-col>
              </div>
            </v-col>
            <v-col
              v-if="param.act === 'update'"
              cols="12"
              md="2"
              style="padding: 0"
            ></v-col>
            <v-col
              v-if="param.act === 'update'"
              cols="12"
              md="5"
              style="padding: 0"
            >
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Supplier Code
                  </p>
                </v-col>
                <v-col
                  v-if="form.vendor !== undefined"
                  cols="12"
                  style="padding: 0"
                >
                  <v-text-field
                    readonly
                    :value="form.vendor.code"
                    dense
                    outlined
                  />
                </v-col>
              </div>
            </v-col>
            <!-- ---------------------------------------------------------------- -->

            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Qty
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.qty"
                    type="number"
                    min="0.01"
                    dense
                    outlined
                    style="margin: 0"
                    :rules="qtyRules"
                  />
                </v-col>
              </div>
            </v-col>

            <v-col cols="12" md="2" style="padding: 0"> </v-col>

            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0"
                  ><p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Satuan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-autocomplete
                    v-if="param.act === 'add' && !select_from_catalogue"
                    v-model="form.uom"
                    :items="dropdownUnit"
                    clearable
                    outlined
                    item-text="name"
                    item-value="id"
                    hide-no-data
                    return-object
                    style="margin: 0"
                    :rules="unitRules"
                    dense
                  />
                  <div v-else>
                    <div v-if="Object.keys(this.form).length > 0">
                      <div v-if="form.product != null">
                        <v-autocomplete
                          v-if="form.product.code == null"
                          v-model="form.uom"
                          :items="dropdownUnit"
                          clearable
                          outlined
                          item-text="name"
                          item-value="id"
                          hide-no-data
                          return-object
                          style="margin: 0"
                          :rules="unitRules"
                          dense
                        />
                        <v-autocomplete
                          v-else
                          v-model="form.uom"
                          :items="dropdownUnit"
                          outlined
                          item-text="name"
                          item-value="id"
                          hide-details
                          hide-no-data
                          return-object
                          style="margin: 0"
                          :rules="unitRules"
                          dense
                          readonly
                        />
                      </div>
                      <v-autocomplete
                        v-else
                        v-model="form.uom"
                        :items="dropdownUnit"
                        outlined
                        item-text="name"
                        item-value="id"
                        hide-no-data
                        return-object
                        style="margin: 0"
                        dense
                        readonly
                        :rules="unitRules"
                      />
                    </div>
                  </div>
                </v-col>
              </div>
            </v-col>

            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Harga Penawaran
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.quotation_price_per_unit"
                    dense
                    outlined
                    :rules="quotationRules"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" md="2" style="padding: 0"></v-col>

            <v-col
              cols="12"
              md="5"
              style="padding: 0"
              v-if="param.act === 'update'"
            >
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Harga Terakhir
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.last_price"
                    dense
                    outlined
                    readonly
                  />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Budget / Item
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.budget_price_per_unit"
                    dense
                    outlined
                    :rules="budgetRules"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="2"
              style="padding: 0"
              v-if="param.act === 'update'"
            ></v-col>

            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Total
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="form.budget_price_total"
                    dense
                    outlined
                    readonly
                  />
                </v-col>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="2"
              style="padding: 0"
              v-if="param.act === 'add'"
            ></v-col>

            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Currency
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-autocomplete
                    v-model="form.currency"
                    :items="dropdownCurrency"
                    outlined
                    item-text="code"
                    item-value="id"
                    hide-details
                    hide-no-data
                    return-object
                    style="margin: 0"
                    dense
                  />
                </v-col>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="2"
              style="padding: 0"
              v-if="param.act === 'update'"
            ></v-col>

            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Stock
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.current_stock"
                    type="number"
                    dense
                    outlined
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="2"
              style="padding: 0"
              v-if="param.act === 'add'"
            ></v-col>

            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl Diperlukan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0"
                  ><v-text-field
                    v-model="form.estimate_date_use"
                    outlined
                    dense
                    :label="form.estimate_date_use"
                    type="date"
                    name="date"
                    step="1"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="2"
              style="padding: 0"
              v-if="param.act === 'update'"
            ></v-col>
            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Estimasi data dilengkapi
                    <v-tooltip right color="info">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          color="blue"
                          class="mr-1"
                          >mdi-information-outline</v-icon
                        >
                      </template>
                      <span
                        >Kolom ini diisi berdasarkan tanggal estimasi user harus
                        melengkapi data produk,</span
                      ><br />
                      <span
                        >sebagai timbal balik pengisian barang tanpa melalui
                        katalog</span
                      ><br />
                      <span
                        >Max rentang waktu estimasi adalah 1 bulan setelah
                        barang ini diinput disistem</span
                      >
                    </v-tooltip>
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.estimate_fulfillment"
                    outlined
                    dense
                    :label="form.estimate_fulfillment"
                    type="date"
                    name="date"
                    step="1"
                    :rules="estimateRules"
                  />
                </v-col>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="5"
              style="padding: 0"
              v-if="param.act === 'update'"
            >
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nomor PR
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field :value="form.pr_no" dense outlined readonly />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" md="2" style="padding: 0"> </v-col>

            <v-col
              cols="12"
              md="5"
              style="padding: 0"
              v-if="param.act === 'update'"
            >
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Status
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="form.status !== undefined ? form.status.name : ''"
                    dense
                    outlined
                    readonly
                  />
                </v-col>
              </div>
            </v-col>
            <!-- upload file -->
            <!-- <v-col
              cols="12"
              md="2"
              style="padding: 0"
              v-if="param.act === 'add'"
            ></v-col>
            <v-col cols="12" md="5" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0"
                  ><p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Upload File
                    <span style="font-size: 9px; color: orange">
                      <b>(cooming soon)</b>
                    </span>
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-file-input
                    disabled
                    prepend-icon=""
                    outlined
                    dense
                  ></v-file-input>
                </v-col>
              </div>
            </v-col> -->

            <v-col
              cols="12"
              md="2"
              style="padding: 0"
              v-if="param.act === 'add'"
            ></v-col>

            <v-col cols="12">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Referensi Vendor Lain
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-autocomplete
                    v-model="form.vendor_rec"
                    :items="dropdownVendor"
                    :filter="vendorCustomFilter"
                    clearable
                    outlined
                    item-text="name"
                    item-value="id"
                    hide-details
                    hide-no-data
                    return-object
                    :loading="loading"
                    :search-input.sync="searchVendor"
                    dense
                    @keydown.enter.prevent="vendorSearch(searchVendor)"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title class="d-flex">
                            <span style="font-size: 12px; margin-right: 5px">
                              ({{ data.item.code }})
                            </span>
                            {{ data.item.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
              </div>
            </v-col>
            <v-col cols="12">
              <div style="padding: 0 10px; margin-top: 15px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Link Toko (<span style="font-size: 10px; color: orange"
                      >isi jika nama vendor online shop !</span
                    >)
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    @click:append="openStoreLink(form.store_link)"
                    v-model="form.store_link"
                    type="text"
                    dense
                    outlined
                    append-icon="mdi-open-in-new"
                    prepend-icon=""
                  />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" style="padding: 0; margin-top: 10px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Deskripsi
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-textarea
                    v-model="form.description"
                    dense
                    auto-grow
                    outlined
                  />
                </v-col>
              </div>
            </v-col>
            <v-col style="padding: 0" v-if="param.items !== undefined">
              <v-col style="padding: 0" v-if="param.items !== null">
                <v-col
                  v-if="param.items.status.id === 5"
                  md="12"
                  style="padding: 0"
                >
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Alasan Cancel
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-textarea
                        :value="param.items.cancel_reason"
                        dense
                        auto-grow
                        outlined
                        readonly
                        disabled
                      />
                    </v-col>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="error" text outlined @click="close" :loading="loading">
            close
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            v-if="
              getUserProfile.level.find(({ id }) => id === '41') === undefined
            "
            color="primary"
            type="submit"
            text
            outlined
            :disabled="detail.status.id !== 0"
            :loading="loading"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
      <div>
        <DetailItem
          @showMsgDialog="showMsgDialog"
          :proc="proc"
          :selectedItem="selectedItem"
          :uploadAPI="uploadAPI"
        />
      </div>
    </v-form>
    <!-- </v-container>
    </div> -->
  </v-dialog>
  <!-- </div> -->
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import buildType from '../../../services/buildType'
import moment from 'moment'
export default {
  props: ['param', 'detail', 'wWidth', 'dropdownUnit', 'dropdownCurrency'],
  components: {
    DetailItem: () => import('./DetailItemAndVendor.vue')
  },
  data() {
    return {
      proc: buildType.apiURL('proc'),
      uploadAPI: buildType.apiURL('upload2'),
      dialog: false,
      selected: null,
      catalogueItems: [],
      search: null,
      select: null,
      loading: false,
      form: {},
      select_from_catalogue: true,
      itemNameRules: [],
      detailRules: [],
      qtyRules: [],
      unitRules: [],
      estimateRules: [],
      budgetRules: [],
      quotationRules: [],
      odooItem: null,
      selectedItem: null,
      dropdownVendor: [],
      searchVendor: null,
      selectVendor: null
    }
  },
  watch: {
    select_from_catalogue() {
      if (!this.select_from_catalogue) {
        this.form.product = {
          id: null,
          name: null,
          code: null
        }
      } else {
        this.form.product = null
      }
    },
    search() {
      if (this.search === null || this.search === '') {
        this.catalogueItems = []
      }
    },
    selected() {
      if (this.selected !== null) {
        if (this.selected.product.uom_id !== null) {
          this.form.uom = {
            id: this.selected.product.uom_id,
            name: this.selected.product.uom_name
          }
        } else {
          this.form.uom = null
        }
        if (this.selected.product.currency_id != null) {
          this.form.currency = {
            id: this.selected.product.currency_id,
            code: this.selected.product.currency_code,
            symbol: this.selected.product.currency_symbol
          }
        }
        if (this.selected.qty != undefined && this.selected.qty != null) {
          this.form.qty = this.selected.qty
        }
        if (
          this.selected.budget_price_per_unit != undefined &&
          this.selected.budget_price_per_unit != null
        ) {
          this.form.budget_price_per_unit = this.selected.budget_price_per_unit
        }
        if (
          this.selected.estimate_date_use != undefined &&
          this.selected.estimate_date_use != null &&
          this.selected.estimate_date_use != ''
        ) {
          this.form.estimate_date_use = moment(
            new Date(this.selected.estimate_date_use)
          ).format('yyyy-MM-DD')
        }

        if (
          this.selected.vendor != undefined &&
          this.selected.vendor.name != null &&
          this.selected.vendor.name != ''
        ) {
          this.vendorSelections(this.selected.vendor.name)
          this.form.vendor_rec = this.selected.vendor
        }
        this.checkItemFromOdoo()
      }
    }
  },
  computed: {
    ...mapGetters([
      'getUserProfile'
      // 'getDropdownProduct',
      // 'getDropdownVendor'
      // "getDropdownDocStatus",
    ])
  },
  methods: {
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    openDetailItem(obj) {
      console.log('>>openDetailItem', obj)
      this.selectedItem = obj
      setTimeout(() => {
        document.getElementById('fpbDetailItem').click()
      }, 500)
    },
    enterSearch(val) {
      val && val !== this.select && this.querySelections(val)
    },
    close(val) {
      this.select_from_catalogue = true
      setTimeout(() => {
        if (val) {
          this.$emit('loadPage')
        }
        this.dialog = false
        this.form = {}
        this.selected = null
        this.odooItem = null

        this.itemNameRules = []
        this.qtyRules = []
        this.unitRules = []
        this.detailRules = []
        this.estimateRules = []
        this.budgetRules = []
        this.quotationRules = []
        this.catalogueItems = []
      }, 200)
    },
    clickOutside() {
      this.$emit('loadPage')
      this.form = null
      this.dialog = {}
    },
    add() {
      this.form = {
        request_id: this.detail.id,
        product: null,
        qty: 0,
        budget_price_per_unit: 0,
        quotation_price_per_unit: 0,
        vendor: null,
        has_budget: 0,
        estimate_date_use: null,
        description: '',
        current_stock: 0,
        uom: null,
        estimate_fulfillment: null,
        currency: null,
        vendor_rec: null,
        store_link: null
      }
      if (this.detail.budget_plan != null) {
        this.querySelections('')
      }
    },
    update() {
      setTimeout(() => {
        let estimate = null
        let uom = null
        if (
          this.param.items.estimate_date_use != null &&
          this.param.items.estimate_date_use != ''
        ) {
          // this.param.items.estimate_date_use = new Date().toLocaleDateString()
          estimate = new Date(this.param.items.estimate_date_use)
        }
        //  else {
        //   estimate = new Date().toLocaleDateString()
        // }
        if (this.param.items.uom_id != null) {
          uom = {
            id: this.param.items.uom_id,
            name: this.param.items.uom
          }
        }
        this.form = {
          request_id: this.detail.id,
          product: this.param.items.product,
          qty: this.param.items.qty,
          budget_price_per_unit: this.param.items.budget_price_per_unit,
          quotation_price_per_unit:
            this.param.items.quotation_price_per_unit !== undefined
              ? this.param.items.quotation_price_per_unit
              : 0,
          vendor: this.param.items.vendor,
          has_budget: this.param.items.has_budget,
          estimate_date_use:
            estimate != null ? moment(estimate).format('yyyy-MM-DD') : null,
          description:
            this.param.items.description === ''
              ? this.param.items.product.name
              : this.param.items.description,
          budget_price_total: this.param.items.budget_price_total,
          pr_no: this.param.items.pr_no,
          status: this.param.items.status,
          current_stock: this.param.items.current_stock || 0,
          uom: uom,
          cancel_reson: this.param.items.cancel_reson,
          estimate_fulfillment: this.param.items.estimate_fulfillment,
          vendor_catalogue_id: this.param.items.vendor_catalogue_id,
          currency: null,
          vendor_rec: this.param.items.vendor_rec,
          store_link: this.param.items.store_link,
          purchase_type: this.param.items.purchase_type,
          last_price: this.param.items.last_price
        }
        if (this.param.items.currency_id) {
          this.form.currency = {
            id: this.param.items.currency_id.toString(),
            code: this.param.items.currency_code,
            symbol: this.param.items.currency_symbol
          }
        }
        // console.log(this.form)
        if (this.param.items.vendor_rec.name != null) {
          this.vendorSearch(this.param.items.vendor_rec.name)
        }
        console.log(this.form)
      }, 200)
    },
    submit() {
      const self = this
      this.itemNameRules = [(v) => !!v || 'Item is required']
      this.qtyRules = [
        (v) => !!v || 'QTY is required',
        (v) => v > 0 || 'QTY must be more than 0'
      ]
      this.unitRules = [(v) => !!v || 'Satuan is required']
      this.detailRules = [(v) => !!v || 'Deskripsi is required']
      this.budgetRules = [
        (v) =>
          !/[^0-9.]/.test(v) || 'Only numbers and decimal point (.) are allowed'
      ]
      // [
      //   (v) => !/[^0-9]/.test(v) || 'Cannot use special character or alphabet '
      // ]
      this.quotationRules = [
        (v) =>
          !/[^0-9.]/.test(v) || 'Only numbers and decimal point (.) are allowed'
      ]

      if (this.detail.company.id != 5) {
        if (this.form.product !== null) {
          if (this.form.product.code === null) {
            this.estimateRules = [
              (v) => !!v || 'Estimasi is required',
              (v) => this.getDiffDays(v) <= 30 || 'Max 30 days'
            ]
          }
        }
      }
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          self.createNewForm(self.form)
        }
      })
    },
    createNewForm(form) {
      this.loading = true

      try {
        const newForm = {
          request_id: form.request_id,
          qty: form.qty,
          budget_price_per_unit: form.budget_price_per_unit,
          quotation_price_per_unit: Number(form.quotation_price_per_unit),
          has_budget: form.has_budget ? 1 : 0,
          estimate_date_use: form.estimate_date_use,
          description: form.description,
          current_stock: form.current_stock,
          uom_id: form.uom !== null ? form.uom.id : null,
          uom_name: form.uom !== null ? form.uom.name : null,
          estimate_fulfillment: form.estimate_fulfillment,
          budget_plan_id:
            this.detail.budget_plan != null ? this.detail.budget_plan.id : null,
          store_link: form.store_link
        }
        if (form.currency != null) {
          Object.assign(newForm, {
            currency_id: form.currency.id,
            currency_code: form.currency.code,
            currency_symbol: form.currency.symbol
          })
        }

        if (this.param.act === 'update') {
          Object.assign(newForm, {
            act: this.param.act,
            id: this.param.items.id,
            product_id:
              form.product.id !== null ? Number(form.product.id) : null,
            product_name: form.product.name,
            product_code: form.product.code,
            vendor_id: form.vendor !== null ? Number(form.vendor.id) : null,
            vendor_name: form.vendor !== null ? form.vendor.name : null,
            vendor_code: form.vendor !== null ? form.vendor.code : null,
            vendor_rec_id:
              form.vendor_rec !== null ? Number(form.vendor_rec.id) : null,
            vendor_rec_name:
              form.vendor_rec !== null ? form.vendor_rec.name : null,
            vendor_rec_code:
              form.vendor_rec !== null ? form.vendor_rec.code : null
          })
        } else {
          if (!this.select_from_catalogue) {
            Object.assign(newForm, {
              act: this.param.act,
              product_id: null,
              product_name: this.form.product.name,
              product_code: null,
              last_price: 0,
              vendor_id: null,
              vendor_name: null,
              vendor_code: null,
              vendor_rec_id: null,
              vendor_rec_name: null,
              vendor_rec_code: null,
              is_item_match_with_odoo: 1
            })
          } else {
            console.log('heree', this.selected, this.form.vendor_rec)
            Object.assign(newForm, {
              act: this.param.act,
              product_id:
                this.selected.product.id != null
                  ? Number(this.selected.product.id)
                  : null,
              product_name: this.selected.product.name,
              product_code: this.selected.product.code,
              last_price: this.selected.product.last_price,
              vendor_id:
                this.selected.vendor !== null
                  ? Number(this.selected.vendor.id)
                  : null,
              vendor_name:
                this.selected.vendor !== null
                  ? this.selected.vendor.name
                  : null,
              vendor_code:
                this.selected.vendor !== '' ? this.selected.vendor.code : null,
              vendor_rec_id:
                this.form.vendor_rec != null
                  ? Number(this.form.vendor_rec.id)
                  : null,
              vendor_rec_name:
                this.form.vendor_rec != null ? this.form.vendor_rec.name : null,
              vendor_rec_code:
                this.form.vendor_rec != null ? this.form.vendor_rec.code : null,
              is_item_match_with_odoo:
                this.odooItem != null
                  ? this.odooItem.status == '00'
                    ? 1
                    : 0
                  : 0
            })
            if (this.detail.budget_plan != null) {
              Object.assign(newForm, {
                rab_item_id: this.selected.id,
                rab_qty: this.selected.qty,
                rab_qty_remain: this.selected.qty_remain
              })
            }
          }
        }
        console.log('save>>>', newForm)
        this.save(newForm)
        // this.loading = false
      } catch (error) {
        console.log(`error on form add item: ${error.message}`)
        this.loading = false
      }
    },
    save(form) {
      axios
        .post(`${this.proc}fpb/save_detail`, form)
        .then((res) => {
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            // if (this.param.act === 'add') {
            this.close(true)
            //   this.$emit('loadPage')
            // } else {
            //   this.$emit('loadPage')
            // }
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    console.log('HERE 3')
                    xFlag = true
                  }
                } else {
                  console.log('HERE 2')
                  xFlag = true
                }
              } else {
                console.log('HERE 1')
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }

          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    querySelections(v) {
      const getCatalogue = () => {
        return new Promise((resolve) => {
          let url = ''
          if (this.detail.budget_plan != null) {
            url = `${this.proc}rab/detail_dropdown?request_id=${this.detail.budget_plan.id}&keyword=${v}`
          } else {
            url = `${this.proc}vendor/catalogue/dropdown_product?keyword=${v}`
          }
          axios
            .get(
              // `${this.proc}vendor/catalogue/list?keyword=${v}&offset=0&limit=10&vendor_id=&category_id=`
              url
            )
            .then((res) => {
              resolve(res.data.data)
            })
        })
      }
      this.loading = true
      getCatalogue().then((res) => {
        if (res !== undefined) {
          this.catalogueItems = res
        } else {
          this.catalogueItems = []
        }
        this.loading = false
      })
    },
    customFilter(item, queryText, itemText) {
      if (item.vendor.name === null || item.vendor.code === null) {
        return (
          item.product.name
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1 ||
          item.product.code
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1
        )
      }
      return (
        item.product.name
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.product.code
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.vendor.name
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.vendor.code
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      )
    },
    vendorCustomFilter(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      )
    },
    checkItemFromOdoo() {
      console.log(this.selected)
      const itemArr = []

      const xItem = {
        code: this.selected.product.code,
        name: this.selected.product.name,
        uom: this.selected.product.uom_name,
        index: 0
      }

      itemArr.push(xItem)
      axios
        .post(`${this.proc}fpb/odoo/check_item`, { items: itemArr })
        .then((res) => {
          console.log(res)
          if (res.data.status_code === '00') {
            this.odooItem = res.data.data[0]
          }
          setTimeout(() => {
            this.loading = false
          }, 200)
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', `${err}`, false)
        })
    },

    vendorSearch(val) {
      val && val != this.selectVendor && this.vendorSelections(val)
    },
    vendorSelections(v) {
      const getVendor = () => {
        return new Promise((resolve) => {
          axios
            .get(
              // `${this.proc}vendor/catalogue/list?keyword=${v}&offset=0&limit=10&vendor_id=&category_id=`
              `${this.proc}vendor/dropdown?keyword=${v}&offset=0&limit=100&order_by=code&order_type=desc`
            )
            .then((res) => {
              console.log('vendor dropdown>>>', res)
              resolve(res.data.data)
            })
        })
      }

      // this.loading = true
      getVendor().then((res) => {
        if (res != undefined) {
          this.dropdownVendor = res
        } else {
          this.dropdownVendor = []
        }
        // this.loading = false
      })
    },
    getDiffDays(v) {
      console.log('estimate_date>>>>', v)
      const dateNow = new Date()
      const date2 = new Date(v)

      // Calculating the time difference
      // of two dates
      const Difference_In_Time = date2.getTime() - dateNow.getTime()

      // Calculating the no. of days between
      // two dates
      const Difference_In_Days = Math.round(
        Difference_In_Time / (1000 * 3600 * 24)
      )
      console.log('Difference_In_Days>>>>', Difference_In_Days)
      return Difference_In_Days
    },
    openStoreLink(link) {
      if (link != null && link != '') {
        window.open(link, '_blank')
      } else {
        this.showMsgDialog('info', 'Link toko tidak tersedia', false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media (max-width: 808px) {
}
</style>
